(ns app.front.view.property.v2.workspace-reassign.subs
  (:require [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.periodic-inspection.model :as periodic-inspection-model]
            [app.front.view.property.subs :as property-subs]
            [app.front.view.property.v2.workspace-reassign.events :as events]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::state
  :-> ::events/state)

(rf/reg-sub ::reassignable-workspaces
  :<- [::property-subs/workspaces]
  (fn [workspaces _]
    (->> workspaces
         ;; Supplemental workspaces are tied to another workspace rather than moved independently.
         (remove (comp ptc-model/additional-permit-type? :workspace/permit-type))
         ;; Inspection rounds move with their periodic parent workspace, which is listed instead.
         (remove periodic-inspection-model/child-workspace?))))

(rf/reg-sub ::selected
  :<- [::state]
  :-> (comp set :selected))

(rf/reg-sub ::all-workspace-ids
  :<- [::reassignable-workspaces]
  (fn [workspaces _]
    (mapv :db/id workspaces)))

(rf/reg-sub ::selected-workspace-ids
  :<- [::selected]
  :<- [::all-workspace-ids]
  (fn [[selected workspace-ids] _]
    (set (filter selected workspace-ids))))

(rf/reg-sub ::workspace-items
  :<- [::property-subs/workspace-items]
  :<- [::all-workspace-ids]
  (fn [[items workspace-ids] _]
    (let [ids (set workspace-ids)]
      (vec (filter #(contains? ids (:db/id %)) items)))))

(rf/reg-sub ::reassigning
  :<- [::state]
  :-> :reassigning)

(rf/reg-sub ::reassigning-for-this-property?
  :<- [::reassigning]
  :<- [::property-subs/property-id]
  (fn [[reassigning property-id] _]
    (boolean (and reassigning (= (:for-property-id reassigning) property-id)))))

(def ^:private destination-relations
  "Workspaces move freely in either direction along a subdivision: onto a parcel split off from this
  property, or back onto the property this one was split off from. Merge relations are not
  destinations."
  #{:property-relations/subdivided-to
    :property-relations/subdivided-from})

(rf/reg-sub ::destinations
  :<- [::property-subs/property-relations]
  (fn [relations _]
    (->> relations
         (filter (fn [{:keys [relation entity-id state]}]
                   (and (contains? destination-relations relation)
                        entity-id
                        ;; The backend rejects historical targets, so don't offer them.
                        (not= :property.state/historical state))))
         (map #(select-keys % [:entity-id :address :property-id]))
         (sort-by #(or (:property-id %) (:address %) (str (:entity-id %))))
         vec)))

(rf/reg-sub ::selected-destination
  :<- [::destinations]
  :<- [::reassigning]
  (fn [[destinations {:keys [destination-property-id]}] _]
    (first (filter #(= destination-property-id (:entity-id %)) destinations))))

(rf/reg-sub ::section-visible?
  :<- [::ff/enabled? :feature-flag.id/property-data-integrity-tooling]
  :<- [::property-subs/editing?]
  :<- [::property-subs/can-edit?]
  :<- [::property-subs/property-management-group?]
  (fn [[flag-enabled? editing? can-edit? management-group?] _]
    (boolean (and flag-enabled? editing? can-edit? management-group?))))
